module.exports = __webpack_public_path__ + "img/PDF_DOC.37de177b.png";